/**
 * Focus the first input field with an error
 * @param {object} [options={}] - references of providers inputs
 * @param {object} options.cardNumber - card number reference
 * @param {object} options.cardExpiration - card expiration reference
 * @param {object} options.cardSecurityCode - cvc reference
 * @param {object} options.iban - iban reference
 * @param {string} providerName
 * @param {string} [errorClass=.-validationError] - validation error class
 */
const focusFirstError = ({ cardNumber, cardExpiration, cardSecurityCode, iban } = {}, providerName = '', errorClass = '.-validationError') => {
	// If there is no element in error state, do nothing
	const anyInvalidElement = document.querySelector(errorClass);
	if (!anyInvalidElement) {
		return;
	}
	// If there is an input child element in the invalid parent element, focus standard DOM element
	const invalidInputs = anyInvalidElement.querySelectorAll('input:not([type="hidden"])') ?? [];
	if (invalidInputs.length) {
		invalidInputs[0].focus();
		return;
	}
	// Handle custom cases where we have provider elements inside of iframes
	const invalidFormLine = anyInvalidElement.querySelector(`.formLine${errorClass}`);
	const invalidFormLineClassList = Array.from((invalidFormLine ?? anyInvalidElement).classList);
	// Focus first invalid creditCard payment method input
	if (cardNumber && cardExpiration && cardSecurityCode) {
		if (invalidFormLineClassList.includes('-cardNumber')) {
			cardNumber[providerName]().autoFocus();
		} else if (invalidFormLineClassList.includes('-cardExpiration')) {
			cardExpiration[providerName]().autoFocus();
		} else if (invalidFormLineClassList.includes('-cardSecurityCode')) {
			cardSecurityCode[providerName]().autoFocus();
		}
	}
	// Focus first invalid directDebit payment method input
	if (iban) {
		if (invalidFormLineClassList.includes('-iban')) {
			iban[providerName]().autoFocus();
		}
	}
};

export default focusFirstError;
